import Vue from 'src/views/base'
import { Component } from 'vue-property-decorator'
import template from './index.vue'

@Component({
    name: 'newHeader',
    mixins: [ template ]
})
export default class ContentLayout extends Vue {
    handleHome() {
        // open(this.config.api.PLZ)
        location.href = this.config.api.LZS
    }
}



// WEBPACK FOOTER //
// ./src/views/components/new-header/index.js